import { colors } from '@/theme/colors';
import {} from '../../i18n/locales/en';
import {} from '../../i18n/locales/ko';
import styled from 'styled-components';

type MultiLineTextProps = {
  translationKey?: string;
  lineHeight?: string;
};

export const MultiLineText = ({
  translationKey = '',
  lineHeight = '120%',
}: MultiLineTextProps) => {
  return (
    <Span
      dangerouslySetInnerHTML={{
        __html: translationKey.replace(/\n/g, '<br />'),
      }}
      $lineHeight={lineHeight}
    />
  );
};

interface SpanProps {
  $lineHeight: string;
}
const Span = styled.span<SpanProps>`
  line-height: ${({ $lineHeight }) => $lineHeight};
  strong {
    color: ${colors.infoHover};
  }
`;
